const {getCurrentBreakpoint} = require('../services/breakpoints');

function getPubstackInformation(slot) {
	const currentBp = getCurrentBreakpoint();

	let placement;

	if (typeof slot.placement === 'object') {
		placement = slot.placement[currentBp]?.split('_');
	} else {
		placement = slot.placement.split('_');
	}

	if (!Array.isArray(placement) || placement.length < 4 || placement.length > 5) {
		console.warn(`[ADVERT] Pubstack - Invalid placement format for slot ${slot.name} - ${slot.placement}`);

		return null;
	}

	return {
		'adUnitName': `${placement[2]}_${placement[placement.length - 1]}`
	};
}

module.exports = {
	getPubstackInformation
};
